module.exports = __webpack_public_path__ + "static/media/16UNODC19.645bfc1e.jpg";